import React, {Component} from "react";
import queryString from "query-string";
import {Row, Col, notification} from "antd";

import UserSearch from "../components/UserSearch";
import apiCodeforces from "../assets/js/apiCodeforces";
import UserInformation from "../components/UserInformation";
import LaddersList from "../components/LaddersList";

import "../assets/css/Ladders.css";

export default class Ladders extends Component {
	state = {
		userInfo: {},
		userProblems: [],
		solvedProblems: new Set()
	};
	requestProblems = null;

	async componentDidMount() {
		
		const q = queryString.parse(window.location.search);

		if (q.handle) {
			const handle = q.handle;
			const user = await apiCodeforces.getUserInfo(handle);
			this.updateUser(user);
		}
	}

	render() {
		return (
			<section className="Ladders">
				<Row className="Ladders__title" type="flex" align="middle">
					<Col xs={ { span: 24 } } sm={ { span: 24 } } md={ { span: 24 } }>
						<h1 className="Ladders__title-ladders">Ladders A2OJ</h1>
					</Col>
				</Row>
				<UserSearch onSearch={ this.updateUser }/>
				<UserInformation user={ this.state.userInfo } />
				<LaddersList solved={ this.state.solvedProblems } />
			</section>
		);
	}

	updateUser = async (userInfo) => {
		try {
			if (userInfo.handle && userInfo.handle.length) {
				const handle = userInfo.handle;
				const userProblems = await this.getUserProblems(handle);
				
				userInfo.solvedProblems = userProblems.length;
				
				const solvedProblems = new Set();
				
				userProblems.forEach(submission => {
					const problem = submission.problem;
					solvedProblems.add(`${problem.contestId}/${problem.index}`);
				})
				
				this.setState({
					userInfo,
					userProblems,
					solvedProblems
				});
				
				if (window.history.replaceState) {
					const newURL = this.updateQueryString("handle", handle);
					window.history.replaceState({
						path: newURL
					}, '', newURL);
				}
		
				this.requestProblems && clearInterval(this.requestProblems);
				this.requestProblems = setInterval(this.updateUserProblems, 4250);
			}
			else if (userInfo.errorHandle) {
				notification["error"]({
					message: 'User handle not found.',
					description:
						'The user handle does not exist or there was a error.',
				});
			}
		} catch (err) {
			console.log(err.message);
		}
	}

	updateUserProblems = async () => {
		if (this.state.userInfo.handle) {
			const user = await apiCodeforces.getUserInfo(this.state.userInfo.handle);
			this.updateUser(user);
		}
	}

	getUserProblems = (handle) => apiCodeforces.getUserProblems(handle);

	updateQueryString = (key, value, options={}) => {
		let url = options.url || window.location.href;
    let re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"), hash;

    hash = url.split('#');
    url = hash[0];
    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null)
            url = url.replace(re, '$1' + key + "=" + value + '$2$3');
				else
            url = url.replace(re, '$1$3').replace(/(&|\?)$/, '');
		}
		else if (typeof value !== 'undefined' && value !== null) {
        const separator = url.indexOf('?') !== -1 ? '&' : '?';
        url = url + separator + key + '=' + value;
    }

    if ((typeof options.hash === 'undefined' || options.hash) && typeof hash[1] !== 'undefined' && hash[1] !== null)
				url += '#' + hash[1];
				
    return url;
	}
}